import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class LaserEnd {
  constructor(game, x, y, flip) {
    this.game = game;
    this.animatedBeam = game.add.sprite(x, y - 8, 'beamSpriteSheet', 1).setOrigin(0);

    this.game.anims.create({
      key: 'lazer',
      frameRate: 15,
      repeat: -1,
      frames: this.game.anims.generateFrameNames('beamSpriteSheet', {
        start: 0,
        end: 11
      })
    });

    this.animatedBeam.play('lazer');

    this.animatedBeam.scaleX = .5;
    this.animatedBeam.scaleY = .5;

    this.ray = game.add.sprite(x, y, Images.DEFAULT_ATLAS, 'laserRay').setOrigin(0);

    if (flip) {
      this.ray.setFlipX(true);
      this.ray.x -= this.ray.width;
      this.animatedBeam.x -= this.ray.width + 80;
      this.animatedBeam.setFlipX(true);
    }
    else {
      this.ray.x -= 60;
      this.animatedBeam.x += 13;
    }
  }

  FadeBeam() {
    Tweens.addTween(this.animatedBeam, 500, { alpha: 0 },Phaser.Math.Easing.None);
  }
}


